const countContainers = document.querySelectorAll('.js-compare-count')

export const addToCompare = productId => {
  const compare = JSON.parse(window.localStorage.getItem('compare')) || []
  const id = parseInt(productId, 10)
  let included = compare.indexOf(id) >= 0
  if (!included) {
    compare.push(id)
  }
  updateCount(compare.length)
  window.localStorage.setItem('compare', JSON.stringify(compare))
}

export const removeFromCompare = productId => {
  const compare = JSON.parse(window.localStorage.getItem('compare'))
  const id = parseInt(productId, 10)
  const removed = compare.filter(item => item !== id)
  window.localStorage.setItem('compare', JSON.stringify(removed))
  updateCount(removed.length)
}

const updateCount = count => {
  // countContainer.innerHTML = count
}

export const initCount = () => {
  if (window.localStorage.getItem('compare')) {
    ;[...countContainers].forEach(countContainer => {
      const compare = JSON.parse(window.localStorage.getItem('compare'))
      countContainer.innerHTML = compare.length
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/compare/helpers/compare.js